import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const UserGroupIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 4.667c0-.507.41-.917.917-.917h11.667c.506 0 .916.41.916.917v11.667c0 .506-.41.916-.917.916H7.667a.917.917 0 0 1-.917-.917V4.667Zm-1.5.583v-.583A2.417 2.417 0 0 1 7.667 2.25h11.667a2.416 2.416 0 0 1 2.416 2.417v11.667a2.416 2.416 0 0 1-2.417 2.416h-.583v.583a2.417 2.417 0 0 1-2.417 2.417H4.667a2.417 2.417 0 0 1-2.417-2.417V7.667A2.417 2.417 0 0 1 4.667 5.25h.583Zm12 13.5v.583c0 .507-.41.917-.917.917H4.667a.917.917 0 0 1-.917-.917V7.667c0-.507.41-.917.917-.917h.583v9.583a2.417 2.417 0 0 0 2.417 2.417h9.583ZM12.262 7.696a1.75 1.75 0 1 1 2.475 2.476 1.75 1.75 0 0 1-2.475-2.476Zm-1.06-1.06a3.25 3.25 0 0 1 4.594-.002l.002.002a3.251 3.251 0 1 1-4.597 0Zm-2.117 7.381a3.124 3.124 0 0 1 2.123-.833h4.584a3.134 3.134 0 0 1 2.905 1.973.75.75 0 0 1-1.394.554 1.632 1.632 0 0 0-1.51-1.027h-4.585a1.624 1.624 0 0 0-1.511 1.027.75.75 0 0 1-1.394-.554c.173-.433.44-.823.782-1.14Z"
      fill="currentColor"
    />
  </IconBase>
);

export default UserGroupIcon;
